import React, { FC, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  ListItemIcon,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

interface DeleteDialogProps {
  title?: string;
  handleDelete: () => void;
  handleMenuClose?: () => void;
  type?: 'comment' | 'avatar' | 'menu';
}

const DeleteDialog: FC<DeleteDialogProps> = ({ title = '', handleDelete, handleMenuClose = () => {}, type = 'menu' }) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    if (type !== 'comment' && type !== 'avatar') {
      handleMenuClose();
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleActionClick = () => {
    handleDelete();
    handleClose();
  };

  return (
    <div>
      {type === 'comment' ? (
        <Button onClick={handleClickOpen} size="small" color="inherit" startIcon={<DeleteIcon />} sx={{ textTransform: 'none' }}>
          Delete
        </Button>
      ) : type === 'avatar' ? (
        <Button onClick={handleClickOpen} size="small" color="secondary" variant="outlined" startIcon={<DeleteIcon />} sx={{ textTransform: 'none' }}>
          Remove
        </Button>
      ) : (
        <MenuItem onClick={handleClickOpen}>
          <ListItemIcon>
            <DeleteIcon sx={{ marginRight: 'var(--space-icon-gap)' }} />
            Delete
          </ListItemIcon>
        </MenuItem>
      )}

      <Dialog open={open} keepMounted onClose={handleClose}>
        <DialogTitle>
          {type === 'comment' ? 'Delete Comment?' : type === 'avatar' ? 'Remove Avatar?' : 'Delete Post?'}
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            {type === 'comment'
              ? 'Are you sure you want to delete your comment?'
              : type === 'avatar'
              ? 'Are you sure you want to remove your avatar?'
              : `Are you sure you want to delete your post titled '${title}'? You can't undo this.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" variant="outlined" size="small">
            Cancel
          </Button>
          <Button onClick={handleActionClick} color="primary" variant="contained" size="small">
            {type === 'comment' ? 'Delete Comment' : type === 'avatar' ? 'Remove Avatar' : 'Delete Post'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DeleteDialog;
